/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from "@emotion/core";

import React, { FC } from "react";
import Dialog from "./Dialog";
import createCtx from "utils/createCtx";

const callAll = (...fns: any[]) => (...args: any[]) =>
  fns.forEach((fn) => fn && fn(...args));

type ModalContextValue = [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>
];

const [useModalContext, ModalContextProvider] = createCtx<ModalContextValue>(
  "Modal Context"
);

const Modal: FC = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return <ModalContextProvider value={[isOpen, setIsOpen]} {...props} />;
};

type EProps = {
  children: React.ReactElement<any>;
};

const ModalDismissButton: FC<EProps> = ({ children: child }) => {
  const [, setIsOpen] = useModalContext();
  return React.cloneElement(child, {
    onClick: callAll(() => setIsOpen(false), child.props.onClick),
  });
};

const ModalOpenButton: FC<EProps> = ({ children: child }) => {
  const [, setIsOpen] = useModalContext();
  return React.cloneElement(child, {
    onClick: callAll(() => setIsOpen(true), child.props.onClick),
  });
};

const ModalContents: FC = (props) => {
  const [isOpen, setIsOpen] = useModalContext();
  return (
    <Dialog isOpen={isOpen} onDismiss={() => setIsOpen(false)} {...props} />
  );
};

export {
  Modal,
  ModalDismissButton,
  ModalOpenButton,
  ModalContents,
  useModalContext,
};
